<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3667_1743)">
<rect width="16" height="16" rx="4" fill="currentColor"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M13.0136 4.21355C13.2639 4.45131 13.274 4.84691 13.0362 5.09714L6.25988 12.2286L2.97456 8.94322C2.73048 8.69914 2.73049 8.30341 2.97457 8.05934C3.21865 7.81526 3.61438 7.81527 3.85845 8.05935L6.23703 10.438L12.13 4.23611C12.3678 3.98588 12.7634 3.97578 13.0136 4.21355Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_3667_1743">
<rect width="16" height="16" rx="4" fill="white"/>
</clipPath>
</defs>
</svg>
